<template>
  <header class="w-full fixed bg-primary-500 z-50">
    <div class="flex gap-8 h-[72px] text-header-foreground max-w-[1040px] mr-auto px-4 sm:px-5 md:h-20 lg:max-w-[1320px] lg:mr-[200px] xl:ml-auto 2xl:mr-auto">
      <slot />
    </div>
  </header>
</template>
